import { DetailedHTMLProps, HTMLAttributes, ReactNode } from 'react';

export function SubListItem({
  isLast,
  children,
  ...props
}: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  isLast: boolean;
  children: ReactNode;
}) {
  return (
    <div
      key={props.key}
      className={`border-neutrals-300 py-2  ${
        isLast ? 'border-b-0' : 'border-b'
      }`}
      {...props}>
      {children}
    </div>
  );
}
